import { render, staticRenderFns } from "./ReturnAgingReport.vue?vue&type=template&id=72a60dba&scoped=true&"
import script from "./ReturnAgingReport.vue?vue&type=script&lang=js&"
export * from "./ReturnAgingReport.vue?vue&type=script&lang=js&"
import style0 from "./ReturnAgingReport.vue?vue&type=style&index=0&id=72a60dba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a60dba",
  null
  
)

export default component.exports